import React, { useState } from 'react';
import Welcome from './components/Welcome';
import Rating from './components/Rating'
import Result from './components/Result'
import PredictionError from './components/PredictionError'
import { Switch, Route, withRouter } from "react-router-dom";
import heroes from './heroes'
import './App.css';

function App({ history }) {
  const [ name, setName ] = useState("")
  const [ ratings, setRatings ] = useState([])
  const [ progress, setProgress ] = useState("start")
  const [ currentHero, setCurrentHero ] = useState({})
  const [ resultHero, setResultHero ] = useState({})
  const [ theHeroes ] = useState(heroes)

  const checkForRedirect = () => !name ? history.push('/') : null



  const reset = () => {
    history.push('/')
    setName("")
    setRatings([])
    setProgress(null)
    setResultHero(null)
  }

  const startRating = (userName, e) => {
    e.preventDefault();
    setName(userName)
    nextHero()
    history.push('/rate')
  }

  const handleNext = heroRating => {
    ratings.push({ "Battle_Tag": name, "Hero": currentHero.name, "Ratings": heroRating.toString() })
    ratings.length < 5 ? nextHero() : submit()
  }

  const predictHero = async () => {
    console.log(ratings)
    // fetch(".netlify/functions/predict_hero", {
    fetch("https://algakovic.eu.pythonanywhere.com/predict", {
      method: "post",
      body: JSON.stringify(ratings),
      headers: {'Content-Type': 'application/json'}
    })
      .then(r => r.json())
      .then(parseResult)
      .catch(console.log)
  }

  const parseResult = data => {
    logErrorCheck(data)
    checkForError(data)
    console.log('\nHere is the data straight from the fetch:')
    console.log(data)
    let heroName = data[0][0]
    // let heroRating = data[0][1]

    const allHeroes = Object.values(theHeroes).flat()
    let resultHero = allHeroes.find(h => h.name === heroName)
    setResultHero(resultHero)
    //setResultHero({name: 'Mercy', shortId: 'IBIwGKDwnWY'})
  }

  const checkForError = data => data.errorMessage ? history.push('/oops') : null

  const logErrorCheck = data => {
    console.log("checking for error")
    console.log(!!data.errorMessage)
  }

  // [
  //   {Battle_Tag: "AwesomeJo", Hero: "Roadhog", Ratings: 4},
  //   {Battle_Tag: "AwesomeJo", Hero: "Pharah", Ratings: 3},
  //   {Battle_Tag: "AwesomeJo", Hero: "Zenyatta", Ratings: 3},
  //   {Battle_Tag: "AwesomeJo", Hero: "Reinhardt", Ratings: 5},
  //   {Battle_Tag: "AwesomeJo", Hero: "Bastion", Ratings: 2}
  // ]

  const nextHero = () => {
    setProgress(`${ratings.length + 1} / 5`)
    switch(ratings.length) {
      case 0:
        setRandom("tank"); break;
      case 1:
        setRandom("damage"); break;
      case 2:
        setRandom("support"); break;
      case 3:
        setRandom("tank"); break;
      case 4:
        setRandom("damage"); break;
      default:
        break
    }
  }

  const setRandom = type => {
    let randomHero = theHeroes[type][Math.floor(Math.random()*theHeroes[type].length)]
    ratings.map(r => r["Hero"]).includes(randomHero.name) ? nextHero() : setCurrentHero(randomHero)
  }

  const submit = () => {
    setResultHero({name: false})
    history.push('/result')
    predictHero()
  }

  const redirectToWelcome = () => {
    history.push('/')
  }

  return (
    <div className="App">
      <header className="App-header">
          <Switch>
            <Route exact path="/" render={(props) => <Welcome {...props} startRating={startRating}/>}/>
            <Route exact path="/rate" render={(props) => <Rating {...props} hero={currentHero} name={name} handleNext={handleNext} progress={progress} redirect={redirectToWelcome} checkForRedirect={checkForRedirect}/>}/>
            <Route exact path="/result" render={ props => <Result {...props} hero={resultHero} restart={reset} redirect={redirectToWelcome} checkForRedirect={checkForRedirect}/>}/>}/>
            <Route exact path="/oops" render={(props) => <PredictionError {...props} restart={reset}/>}/>
          </Switch>
      </header>


    </div>
  );
}

export default withRouter(App);
